import React from "react";
import { IEditService, IEditServiceError } from "../../../store/types/service";
import { useAppSelector } from "../../../store";

const useEditService = (serviceId: string | number) => {
  const service = useAppSelector(({ service }) => service.service);
  const [data, dataSet] = React.useState<IEditService>({
    name: "",
    description: "",
    image: "",
    packages: [],
    price: "",
    id: 0,
  });
  const [err, errSet] = React.useState<IEditServiceError>({
    description: "",
    id: "",
    name: "",
    image: "",
    packages: "",
    price: "",
  });
  const [packageIds, packageIdsSet] = React.useState<(number | null)[]>([]);

  const onLoad = React.useCallback(() => {
    if (service && service.id === Number(serviceId))
      dataSet((prev) => ({
        ...prev,
        image: service.image,
        id: service.id,
        name: service.name,
        description: service.description,
        price: service.price,
        packages:
          service.packages?.map((item) =>
            typeof item === "string" ? item : item.name,
          ) ?? [],
      }));
    if (service && service.id === Number(serviceId)) {
      packageIdsSet(
        service.packages.map((item) =>
          typeof item === "string" ? null : item.id,
        ),
      );
    }
  }, [service, serviceId]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return { data, err, dataSet, errSet, packageIds, packageIdsSet };
};

export default useEditService;
